import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import { Params, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import swal from 'sweetalert2';
import { MatDialog, matDialogAnimations, MatDialogContent } from '@angular/material/dialog';
import { LoginService } from '../../services/login.service';
import { TermsConditionsComponent } from 'src/app/layout/pages/terms-conditions/terms-conditions.component';
import { JwtHelperService } from "@auth0/angular-jwt";
import { TranslateConfigService } from "src/app/features-common/services/translate-config.service";
import { CookieService } from 'ngx-cookie-service';

const helper = new JwtHelperService();
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent extends FeaturesBaseComponent implements OnInit {
  loginForm: FormGroup;
  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  isAgreed: boolean = false;
  popAgree: boolean = true;
  receiveCode = new FormControl('sms');
  //isRemeberMe: boolean = false;
  hide: boolean = true;
  rememberMeCtrl = new FormControl(true)
  isRemeberMe: boolean = true;
  locationDetails: any;
  showSpainshOtp: boolean;
  deviceDetails: any;
  users: any = [];
  //translateService: any;


  constructor(
    private formBuilder: FormBuilder, private translateService: TranslateConfigService, private http: HttpClient, private router: Router, private loginService: LoginService, private deviceService: DeviceDetectorService, public dialog: MatDialog, private cookieService: CookieService
  ) {
    super();
    this.http.get('https://pinocate.co/json/?key=YBkA9fSHWcT2sA1ZE5hxzXUujshpzLY6EhouGQ1smQWY0x2eak').subscribe(
      res => {
        this.locationDetails = res
        this.deviceDetails = this.deviceService.getDeviceInfo();
      })

  }

  ngOnInit() {
    super.ngOnInit();
    /**
     * Set Login form
     */
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
      notification: this.receiveCode,
      isAgreed: this.isAgreed,
    });
    /**
     * Check for cookies
     */
    // if (this.cookieService.check('users')) {
    //   this.users = JSON.parse(this.cookieService.get('users')).users;
    //   this.users = this.users.reverse();
    //   /**
    //   * Filter for unique usernames 
    //   *  @returns unique users
    //   */
    //   this.users = this.users.filter((item, index, inputArray) => {
    //     return inputArray.indexOf(item) == index;
    //   });
    //   this.loginForm.patchValue({
    //     userName: this.users[0]
    //   })
    // }
    /**
   * Set preffred language
   */
    let lang: string = localStorage.getItem("PrefLang") && localStorage.getItem("PrefLang")
      ? localStorage.getItem("PrefLang")
      : "en";
    this.onChnageLanguage(lang);
    localStorage.clear();
    localStorage.setItem("isFrom", "");
    localStorage.setItem("PrefLang", lang)


  }
  // On Language Selection
  onChnageLanguage(lang) {
    if (lang == "en") {
      this.showSpainshOtp = false;
      this.translateService.changeLanguage(lang);
      return;
    }
    this.showSpainshOtp = true;
    this.translateService.changeLanguage(lang);
  }
  onCheckboxChange(e) {
    this.isAgreed = e.checked;
    this.popAgree = e.checked;
  }

  onRememberClick(e) {
    this.isRemeberMe = e.checked;
  }
  // on login form submit
  submit() {
    if (!this.loginForm.valid && this.loginForm.value.userName && this.loginForm.value.password) {
      this.popAgree = false;
      return;
    }
    if (this.loginForm.value.userName !== null && this.loginForm.value.password !== null) {
      // console.log(this.isAgreed)

      let userInfo: any = {};
      userInfo['ip_address'] = this.locationDetails.ip,

        userInfo['device'] = this.deviceDetails.deviceType == 'desktop' ? 'Computer' : this.deviceDetails.deviceType,
        userInfo['system_access_type'] = 'Admin Portal'
      userInfo['user_os'] = this.deviceDetails.os
      userInfo['browser'] = this.deviceDetails.browser
      userInfo['os_version'] = this.deviceDetails.os_version
      userInfo['user_agent'] = this.deviceDetails.userAgent
      userInfo['login_system_location'] = `${this.locationDetails.city} , ${this.locationDetails.region}, ${this.locationDetails.country_name}`

      let params: Params = {
        username: this.loginForm.value.userName,
        password: this.loginForm.value.password,
        notification: this.loginForm.value.notification,
        ip_address: this.locationDetails.ip,
        userInfo: userInfo
      }
      this.getLogin(params)
    }
  }

  // Submit & login
  getLogin(params) {
    this.loginService.login(params).subscribe(res => {
      // console.log(res)
      // console.log(res);
      if (res && res.httpcode == 200 || res.developerMessage == 'Login Success') {

        this.isRemeberMe ? localStorage.setItem('isRemeberMe', 'Yes') : localStorage.setItem('isRemeberMe', 'No')

        let _userMethod: any = {
          username: res.data.username,
          notification: this.loginForm.value.notification,
          notifyBy: res.data.notificationDetails
        }
        /**
        * Set cookie for all userNames
        */
        // if (this.isRemeberMe) {
        //   if (!(this.users.indexOf(this.loginForm.value.userName) === 0)) {
        //     this.users.push(this.loginForm.value.userName);
        //     this.users = this.users.reverse();
        //     /**
        //     * Filter for unique usernames 
        //     *  @returns unique users
        //     */
        //     this.users = this.users.filter((item, index, inputArray) => {
        //       return inputArray.indexOf(item) == index;
        //     });
        //   }
        //   let __users = {};
        //   __users["users"] = this.users;
        //   this.cookieService.set('users', JSON.stringify(__users))

        // }
        localStorage.setItem('userVerify', JSON.stringify(_userMethod))

        if (res.data.jwt && res.data.jwt) {
          localStorage.setItem('accessToken', res.data.jwt);
          localStorage.setItem('id_refresh', res.data.refreshToken)
          const decodedToken = helper.decodeToken(res.data.jwt);
          if (decodedToken.role == "Customer Service") {
            this.router.navigateByUrl('features/retailers/allretailers');
            return
          } else {
            this.router.navigateByUrl('/');
            return
          }
        }

        //success msg
        this.toastrService.success('Verify to proceed.', 'OTP Generated', {})
        this.router.navigate(['verify'])
        return
      }
    });


  }
  openDialog() {
    const dialogRef = this.dialog.open(TermsConditionsComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
